import { Fragment, useState, useEffect, useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import AdventureCard from '../adventures/AdventureCard'
import AdventureCardPlaceholder from '../adventures/AdventureCardPlaceholder'
import messages from './messages'
import API from 'api'
import './widget-activites.scss'

export const buttons = [
  {
    title: <FormattedMessage id='all_adventures_widget' defaultMessage='All' />,
    messageType: 'all',
    type: 'all',
    icon: 'icon-check-all',
  },
  {
    title: <FormattedMessage id='diving' defaultMessage='Diving' />,
    messageType: 'dive-trips',
    type: 'dive_trip',
    icon: 'icon-diver',
    product: '10',
  },
  {
    title: (
      <FormattedMessage id='snorkeling_widget' defaultMessage='Snorkeling' />
    ),
    messageType: 'snorkelling',
    type: 'snorkelling',
    icon: 'icon-snorkeling',
    product: '20',
  },
  {
    title: <FormattedMessage id='courses_widget' defaultMessage='Courses' />,
    messageType: 'courses',
    type: 'course',
    icon: 'icon-course',
    product: '30',
  },
  {
    title: <FormattedMessage id='social_widget' defaultMessage='Social' />,
    messageType: 'social-events',
    type: 'social_event',
    icon: 'icon-champagne',
    product: '40',
  },
  {
    title: (
      <FormattedMessage
        id='conservation_widget'
        defaultMessage='Conservation'
      />
    ),
    messageType: 'conservation',
    type: 'conservation_activity',
    icon: 'icon-conservation',
    product: '50',
  },
]

const Buttons = ({ onTypeChange, selectedType, adventureTypes }) => {
  const showedButtons = buttons.reduce((acc, item) => {
    const onClick = () => {
      onTypeChange(item.type, item.messageType)
    }

    const button = (
      <button
        id={`btn-${item.type}`}
        key={item.type}
        className={`widget-activities-selector__btn ${
          item.type === selectedType && 'active'
        }`}
        onClick={onClick}
      >
        <i className={`font-icons ${item.icon}`} /> {item.title}
      </button>
    )

    if(
      adventureTypes?.includes(item.product) ||
      (item.type === 'all' && adventureTypes?.length > 1)
    ) {
      return [...acc, button]
    }

    return acc
  }, [])

  return (
    <div className='adventure-buttons-container'>
      {showedButtons.length > 1 && showedButtons}
    </div>
  )
}
const placeholderItems = [...new Array(window.innerWidth >= 1024 ? 4 : 3)]

const Adventures = ({ activites, selectedType, messageType }) => {
  const filteredActivities =
    selectedType === 'all'
      ? activites
      : activites.filter((trip) => trip.activityType === selectedType)

  if(!filteredActivities.length) {
    return (
      <div className='no-results'>
        <FormattedMessage {...messages[messageType]} />
      </div>
    )
  }

  return filteredActivities.map((trip) => (
    <AdventureCard adventure={trip} key={trip.id} isWidget />
  ))
}

export default function AdventuresWidget({ diveCenterId, adventureTypes }) {
  const [messageType, setMessageType] = useState('all')
  const [selectedType, setSelectedType] = useState('all')
  const [activities, setActivities] = useState([])
  const [isLoading, setLoading] = useState(true)

  const ref = useRef(null)

  useEffect(() => {
    if(!ref.current) {
      return
    }
    const resizeObserver = new ResizeObserver((entries) => {
      window.parent.postMessage(
        {
          source: 'padi-widget',
          type: 'resize',
          height: entries[0].contentRect.height,
        },
        '*',
      )
    })
    resizeObserver.observe(ref.current)
    return () => resizeObserver.disconnect()
  }, [])

  const onTypeChange = (type, mType) => {
    setMessageType(mType)
    setSelectedType(type)
  }

  useEffect(() => {
    let controller
    let signal

    setLoading(true)

    if('AbortController' in window) {
      controller = new window.AbortController()
      signal = controller.signal
    }

    API(`/api/adventure/v1/dive-centers/${diveCenterId}/all/`, signal)
      .get({ uniq_activity: true, activity_types: adventureTypes })
      .then((items) => {
        setActivities(items.results)
        setLoading(false)
      })

    return () => controller && controller.abort()
  }, [])

  return (
    <Fragment>
      <Buttons
        onTypeChange={onTypeChange}
        selectedType={selectedType}
        adventureTypes={adventureTypes}
      />
      <div
        className={`actitivities-container ${
          isLoading ? 'placeholder-animation' : ''
        }`}
        ref={ref}
      >
        {isLoading ? (
          placeholderItems.map((_, i) => {
            return <AdventureCardPlaceholder key={i} />
          })
        ) : (
          <Adventures
            activites={activities}
            selectedType={selectedType}
            messageType={messageType}
          />
        )}
      </div>
    </Fragment>
  )
}
